import React, { useState } from 'react';

// Constellation Components
import {
    IconChevronDownOutline,
    IconChevronUpOutline,
    Paragraph,
    Text,
} from '@zillow/constellation';

import { StyledInformationDiv, StyledCaretContainer } from './StyledComponents';

const AdditionalInformation = () => {
    const [isGroupInfoTextExpanded, setIsGroupInfoTextExpanded] = useState(false);

    const handleGroupInfoTextClick = () => {
        // Toggle
        setIsGroupInfoTextExpanded(!isGroupInfoTextExpanded);
    };

    return (
        <StyledInformationDiv onClick={handleGroupInfoTextClick}>
            <Text>
                You may be wondering...
            </Text>

            <StyledCaretContainer>
                {isGroupInfoTextExpanded ? <IconChevronUpOutline /> : <IconChevronDownOutline />}
            </StyledCaretContainer>

            <br />
            <br />

            <Paragraph fontType="bodySmallHeading">
                What if a group is applying together?
            </Paragraph>

            {
                isGroupInfoTextExpanded && (
                    <>
                        <br />
                        <Paragraph fontType="bodySmall">
                            Invite one member of the group to apply. On the application form,
                            they will have the opportunity to invite other members.
                        </Paragraph>
                    </>
                )
            }
        </StyledInformationDiv>
    );
};

export default AdditionalInformation;
